import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { assertAdminOrManager } from './Utils/Permission';
import { calcRemaining } from './Utils/DateUtil';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class ExtendSlotUseCase {
  constructor(private repo: SlotRepository) {}
  execute(id: number, days: number, current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current)) {
      throw new Error(getRestrictionMessage('연장', current));
    }

    assertAdminOrManager(current);
    if (days <= 0) throw new Error('연장 일수는 1일 이상이어야 합니다.');
    return this.repo
      .extendSlot(id, days)
      .then(s => ({ ...s, remaining_days: calcRemaining(s.end_date) }));
  }
}